import "../App.css";
import projects from "../assets/data/projects.json";

export default function MyProjects() {
  return (
    <div
      className="tab-pane fade my-projects"
      id="my-projects-tab-pane"
      role="tabpanel"
      aria-labelledby="my-projects-tab"
      tabIndex="0"
    >
      <div className="row">
        <div className="row">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item" aria-current="page">
                <small>
                  <code>$ ~/portfolio/src/components/MyProjects.js</code>
                </small>
              </li>
            </ol>
          </nav>
        </div>
        <h5 className="py-4">
          Have a view of real projects I have worked on:
        </h5>
        {projects.map((project) => (
          <div key={project.id} className="col-md-4 px-3 mb-4">
            <div
              className="card text-center"
              card-type={project.type + "-project"}
            >
              {/* <div className="card-img-top">
                <iframe
                  src={project.link}
                  width="100%"
                  height="200"
                  frameBorder="0"
                  title={project.title}
                ></iframe>
              </div> */}
              <div className="card-body p-5">
                <h5 className="card-title">{project.title}</h5>
                <p className="card-text">{project.description}</p>
                <a
                  href={project.link}
                  target="_blank"
                  rel="noreferrer"
                  style={{ width: "80%" }}
                  className="btn btn-primary btn-custom mx-auto"
                >
                  {"visit " + project.type + " link "}
                  <i className="fa-solid fa-arrow-up-right-from-square"></i>
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
